// =============================================================================
// Breakpoint Check
// =============================================================================

import _page from '../core--object-page';

export default (function() {
    const { breakpointElement, breakpointsArray } = _page;

    // const {current, alternate, order} = breakpoint;
    let currentBreakpoint;

    function _getCurrentBreakpoint() {
        return (currentBreakpoint = window
            .getComputedStyle(breakpointElement, ':before')
            .getPropertyValue('content')
            .replace(/\"/g, '')); // remove quotes
    }
    // Returns True if Direction is coming Down
    const _matchDown = (direction, currentI, passedI) => !direction && currentI <= passedI;

    // Returns True if Direction is coming Up
    const _matchUp = (direction, currentI, passedI) => direction === 'up' && currentI > passedI;

    // Returns True only for when a specific breakpoint matches
    const _matchSpecific = (bpArr, currentI) => {
        for (let i = 0; i < breakpointsArray.length; i += 1) {
            if (currentI === breakpointsArray.indexOf(bpArr[i])) {
                return true;
            }
        }
        return false;
    };

    const _match = (breakpoint, direction) => {
        const currentIndex = breakpointsArray.indexOf(_getCurrentBreakpoint());
        const passedIndex = breakpointsArray.indexOf(breakpoint);

        if (Array.isArray(breakpoint)) {
            if (_matchSpecific(breakpoint, currentIndex)) {
                return true;
            }
        }
        if (_matchUp(direction, currentIndex, passedIndex)) return true;
        if (_matchDown(direction, currentIndex, passedIndex)) return true;
        return false;
    };

    return {
        match(bp, dir) {
            return _match(bp, dir);
        },
        get() {
            return _getCurrentBreakpoint();
        }
    };
})();
